import { BaseCountsItem, PermissionBit } from "../../../api";
import { DataModel } from "../../../models/data-model";

export type AnalyticsItem = BaseCountsItem & {
  unique_patients?: number;
  key?: string;
};

export class Analytics extends DataModel<AnalyticsItem> {
  constructor(
    data: AnalyticsItem[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);
  }

  init() {
    // Rows have no unique field (timestamp repeats across data types) —
    // synthesize a key for table row identity.
    this.data = this.data.map((item) => ({
      ...item,
      key: `${item.timestamp}|${item.data_type}`,
    }));
    super.init();
  }
}
